<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<script>
  export default {
    name: "DpNoDataIndicator"
  }
</script>

<template>
  <div class="no-data-indicator__container">
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
      <g>
        <path d="M57.39,18A29,29,0,0,1,17.71,57.24" fill="none" stroke="#e8e8e8" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="5.34"/>
        <path d="M10.72,51.71A29,29,0,0,1,52.48,11.46" fill="none" stroke="#e8e8e8" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="5.34"/>
        <line x1="6.68" y1="58.23" x2="58.23" y2="6.68" fill="none" stroke="#e8e8e8" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="5.34"/>
      </g>
    </svg>
    <p class="no-data-indicator__text">{{t('nothingToShow.label')}}</p>
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
  .no-data-indicator__container {
    text-align: center;
    padding: 1em;
  }

  .no-data-indicator__text {
    color: #a3a3a3;
  }
</style>

<i18n>
{
  "ar-AE": {
    "nothingToShow": {
      "label": "لا توجد بيانات لعرض"
    }
  },
  "ar-EG": {
    "nothingToShow": {
      "label": "لا توجد بيانات لعرض"
    }
  },
  "ar-SA": {
    "nothingToShow": {
      "label": "لا توجد بيانات لعرض"
    }
  },
  "el-GR": {
    "nothingToShow": {
      "label": "Δεν υπάρχουν δεδομένα προς εμφάνιση"
    }
  },
  "el-CY": {
    "nothingToShow": {
      "label": "Δεν υπάρχουν δεδομένα προς εμφάνιση!"
    }
  },
  "de-DE": {
    "nothingToShow": {
      "label": "Keine Daten zum Anzeigen"
    }
  },
  "de-AT": {
    "nothingToShow": {
      "label": "Keine Daten zum Anzeigen"
    }
  },
  "de-CH": {
    "nothingToShow": {
      "label": "Keine Daten zum Anzeigen"
    }
  },
  "en-US": {
    "nothingToShow": {
      "label": "No data to display"
    }
  },
  "en-GB": {
    "nothingToShow": {
      "label": "No data to display"
    }
  },
  "it-IT": {
    "nothingToShow": {
      "label": "Nessun dato da visualizzare"
    }
  },
  "fr-FR": {
    "nothingToShow": {
      "label": "Aucune donnée à afficher"
    }
  },
  "es-ES": {
    "nothingToShow": {
      "label": "¡No hay información para mostrar"
    }
  },
  "pl-PL": {
    "nothingToShow": {
      "label": "Brak danych do wyświetlenia"
    }
  },
  "nl-NL": {
    "nothingToShow": {
      "label": "Geen gegevens om weer te geven"
    }
  },
  "bg-BG": {
    "nothingToShow": {
      "label": "Няма данни за показване"
    }
  },
  "bs-BA": {
    "nothingToShow": {
      "label": "Nema podataka za prikaz"
    }
  },
  "da-DK": {
    "nothingToShow": {
      "label": "Ingen data at vise"
    }
  },
  "et-EE": {
    "nothingToShow": {
      "label": "Pole andmeid, mida kuvada"
    }
  },
  "fi-FI": {
    "nothingToShow": {
      "label": "Ei näytettäviä tietoja"
    }
  },
  "he-IL": {
    "nothingToShow": {
      "label": "אין נתונים להצגה"
    }
  },
  "ga-IE": {
    "nothingToShow": {
      "label": "Gan aon sonraí le taispeáint"
    }
  },
  "ja-JP": {
    "nothingToShow": {
      "label": "表示するデータがありません"
    }
  },
  "hr-HR": {
    "nothingToShow": {
      "label": "Nema podataka za prikaz"
    }
  },
  "lv-LV": {
    "nothingToShow": {
      "label": "Nav datu, ko parādīt"
    }
  },
  "lt-LT": {
    "nothingToShow": {
      "label": "Nėra rodomų duomenų"
    }
  },
  "pt-PT": {
    "nothingToShow": {
      "label": "Sem dados para exibir"
    }
  },
  "ro-RO": {
    "nothingToShow": {
      "label": "Nu sunt date de afișat"
    }
  },
  "ru-RU": {
    "nothingToShow": {
      "label": "Нет данных для отображения"
    }
  },
  "sv-SE": {
    "nothingToShow": {
      "label": "Ingen data att visa"
    }
  },
  "sk-SK": {
    "nothingToShow": {
      "label": "Žiadne údaje na zobrazenie"
    }
  },
  "cs-CZ": {
    "nothingToShow": {
      "label": "Žádná data k zobrazení"
    }
  },
  "hu-HU": {
    "nothingToShow": {
      "label": "Nincs megjeleníthető adat"
    }
  },
  "fr-BE": {
    "nothingToShow": {
      "label": "Aucune donnée à afficher!"
    }
  },
  "fr-LU": {
    "nothingToShow": {
      "label": "Aucune donnée à afficher!"
    }
  },
  "mt-MT": {
    "nothingToShow": {
      "label": "L-ebda dejta li trid turi"
    }
  },
  "sl-SI": {
    "nothingToShow": {
      "label": "Ni podatkov za prikaz"
    }
  },
  "tr-TR": {
    "nothingToShow": {
      "label": "Gösterilecek bilgi yok"
    }
  },
  "tr-CY": {
    "nothingToShow": {
      "label": "Gösterilecek bilgi yok!"
    }
  },
  "uk-UA": {
    "nothingToShow": {
      "label": "Немає даних для відображення"
    }
  },
  "zh-CN": {
    "nothingToShow": {
      "label": "没有数据显示"
    }
  }
}
</i18n>
